import {
  ADD_ADDRESS_INFORMATION_STARTED,
  ADD_ADDRESS_INFORMATION_SUCCESS,
  ADD_ADDRESS_INFORMATION_ENDED,
  ADD_ADDRESS_INFORMATION_ERROR,
} from '../types/address_info_types';

const initialState = {
  add_address_info_loading: false,
  add_address_info_errors: null,
  add_address_info_success: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ADD_ADDRESS_INFORMATION_STARTED:
      return {
        ...state,
        add_address_info_loading: true,
        add_address_info_errors: null,
        add_address_info_success: null,
      };
    case ADD_ADDRESS_INFORMATION_ENDED:
      return {
        ...state,
        add_address_info_loading: false,
      };
    case ADD_ADDRESS_INFORMATION_ERROR:
      return {
        ...state,
        add_address_info_errors: payload,
      };
    case ADD_ADDRESS_INFORMATION_SUCCESS:
      return {
        ...state,
        add_address_info_success: payload,
      };

    default:
      return state;
  }
}
